import React from 'react';
import { withStyles, Theme, createStyles, LinearProgress, Card, CardHeader, Button, TextField, Select, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";
import  {SelfTimingEvent, EventEntryList, EventClass} from '../models/Event';
import {withTranslation, WithTranslation} from 'react-i18next';
import SelfTimingBackend from "../providers/SelfTimingBackend";
import clone from 'lodash';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

interface Props extends React.Props<any> {
    Event : SelfTimingEvent;
    back : () => void;
  }

  interface State {
      isLoading : boolean;
      haveChanges:boolean;
      classes : EventClass[];
      confirmDeleteClass : EventClass;
      editCourseClass : EventClass;
  }

class EditClasses extends React.Component<Props & WithTranslation,State>
{
    constructor(props:Props & WithTranslation) {
        super(props);
        this.state = {classes : props.Event.Classes != null ? clone.cloneDeep(props.Event.Classes) : [], isLoading:false, haveChanges:false, confirmDeleteClass:null, editCourseClass:null};

    }
    onChange = (idx: number, field : string) => (ev : React.ChangeEvent<HTMLInputElement>) => {
        let cls = this.state.classes;
        (cls[idx] as any)[field] = ev.target.value;
        this.setState({classes : cls, haveChanges:true});        
    }
    addClass = () => {
        let cls = this.state.classes;
        cls.push({Name: "", CourseLength:0, Course:[]});
        this.setState({classes : cls});   
    }
    save = () => {
        let back = new SelfTimingBackend();
        this.setState({isLoading : true});

        let ev = this.props.Event;
        ev.Classes = clone.cloneDeep(this.state.classes);
        back.saveEvent(ev).then((res) => {
            this.setState({haveChanges:false,isLoading:false});
        });
    }
    render()
    {
        const { classes, t } = this.props as any;
        return <div>
            {this.state && this.state.isLoading &&
                <LinearProgress />
            }
                    {this.state.classes && this.state.classes.map((cl : EventClass,idx : number) => {
                        return <div><TextField label="Namn" value={cl.Name} onChange={this.onChange(idx,"Name")}/><TextField label="Banlängd" value={cl.CourseLength} onChange={this.onChange(idx,"CourseLength")}/><Button variant="contained" color="primary" style={{margin:'3px'}} onClick={this.editClassCourse(cl)}>Bandefinition</Button><Button variant="contained" color="primary" style={{margin:'3px'}} onClick={this.askConfirmDeleteClass(cl)}>Ta bort klass</Button></div>
                    })}
                    <p>
                    <Button style={{margin:'3px'}} onClick={this.addClass}  color="primary">Lägg till klass</Button>
                    </p>
                    <p>
                    <Button style={{margin:'3px'}} onClick={this.save} variant="contained" color="primary" disabled={!this.state.haveChanges}>Spara ändringar</Button> 
                    <Button style={{margin:'3px'}} onClick={this.props.back}  variant="contained"  color="primary">Tillbaka</Button>
                    {this.renderDeleteClassDialog()}
                    {this.renderEditCourseDialog()}
                    </p>
                </div>;

    }

    askConfirmDeleteClass = (cl : EventClass) => () => {
        this.setState({confirmDeleteClass:cl})
    }

    confirmDeleteClass = () => {
        let cls = this.state.classes;
        let idx = cls.indexOf(this.state.confirmDeleteClass);
        cls.splice(idx,1);
        this.setState({classes : cls, confirmDeleteClass:null, haveChanges:true});   
    }
    abortDeleteClass = () => {
        this.setState({confirmDeleteClass:null});
    }
    closeEditCourse = () => {
        this.setState({editCourseClass:null});
    }

    editClassCourse = (cl: EventClass) => () => {
        this.setState({editCourseClass:cl});
    }

    renderDeleteClassDialog()
    {
        return this.state && this.state.confirmDeleteClass != null ?<Dialog
        open={this.state.confirmDeleteClass != null}
        onClose={this.abortDeleteClass}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Är du säker på att du vill ta bort klassen?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Eventuella anmälningar och resultat som finns kopplat till klassen kommer också försvinna! <br/>
            <b>Ta bort klass:</b> {this.state.confirmDeleteClass.Name}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.abortDeleteClass} color="primary">
            NEJ AVBRYT
          </Button>
          <Button onClick={this.confirmDeleteClass} color="primary" autoFocus>
            Ja, Ta bort
          </Button>
        </DialogActions>
      </Dialog> : null;
    }
    updateCoursePostValue = (idx : number) => (ev : React.ChangeEvent<HTMLInputElement>) => 
    {
        var course = this.state.editCourseClass;
        course.Course[idx].PostCode = +ev.target.value;
        this.setState({editCourseClass: course, haveChanges:true});
    }
    addCoursePost = () => 
    {
        var course = this.state.editCourseClass;
        let nextCode = course.Course.length > 0 ? course.Course[course.Course.length-1].PostCode+1 : 100;
        course.Course.push({PostCode: nextCode});
        this.setState({editCourseClass: course, haveChanges:true});
    }
    removeCoursePost = (idx : number) => () => {
        var course = this.state.editCourseClass;
        course.Course.splice(idx,1);
        this.setState({editCourseClass: course, haveChanges:true});
    }

    renderEditCourseDialog()
    {
        return this.state && this.state.editCourseClass != null ?<Dialog
        open={this.state.editCourseClass != null}
        onClose={this.closeEditCourse}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Bandefinition " + this.state.editCourseClass.Name}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
                <div style={{display:'flex', borderBottom: '1px dotted black'}}>
                    <div style={{flex:1}}>Start</div><div style={{width:50}}>0</div>
                    <div style={{width:50}}></div>
                </div>
                {this.state.editCourseClass.Course && this.state.editCourseClass.Course.map((post, idx)=>{
                    return  <div style={{display:'flex'}}>
                    <div style={{flex:1}}>{idx+1}</div>
                    <div style={{width:50}}><TextField onChange={this.updateCoursePostValue(idx)} value={post.PostCode}/></div>
                    <div style={{width:50}}><RemoveCircleIcon onClick={this.removeCoursePost(idx)}/></div>
                    </div>;
                })}
                <div style={{display:'flex'}}>
                    <div style={{flex:1}}><Button color="primary" onClick={this.addCoursePost}>Lägg till kontroll</Button></div><div style={{width:50}}></div>
                </div>
                <div style={{display:'flex',borderTop: '1px dotted black'}}>
                <div style={{flex:1}}>Mål</div><div style={{width:50}}>90</div><div style={{width:50}}></div>
                </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeEditCourse} color="primary" autoFocus>
            Stäng
          </Button>
        </DialogActions>
      </Dialog> : null;
    }
}

const useStyles = ({ palette, spacing }: Theme) => createStyles({
  
    tableHeader: {
        backgroundColor: palette.primary.light,
        color: 'white'
    },
    formControl: {
        
        margin: '3px',
        minWidth: 200,
      },
      cardHeader: {
        backgroundColor: '#FFFFFF',
        color: '#000000'
      },
        cardHeaderTitle: {
            fontSize: '10px',
            lineHeight: '10px'
        }
  
});

export default withStyles(useStyles)(withTranslation()(EditClasses));